module.exports = __webpack_public_path__ + "static/media/arrow_up.d18e2b64.svg";